import HtmlElement from '../../../Elements/HtmlElement';

/**
 * CtaLayer
 */
const CtaLayer = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		CTA_LAYER: '.cta-layer',
		CLOSE: '.cta-layer-close'
	};

	/**
	 * CtaLayer
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class CtaLayer extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this.isVisible = false;
			this._wasVisible = false;

			this._checkVisibility();

			$(window).on('scroll', () => {
				this._checkVisibility();
			});

			this.$element.find(Selector.CLOSE).on('click', () => {
				this._hide();
			});

			window.addEventListener('resize', () => {
				if (this._isResponsive() && this.isVisible) {
					$('.footer-bar').css('--cta-layer-height', `${this.$element.outerHeight() + 5}px`);
				} else {
					$('.footer-bar').css('--cta-layer-height', ``);
				}
			});

			this._setOffset();

			window.addEventListener('scroll', () => {
				this._setOffset();
			});
		}

		_checkVisibility() {
			let threshold = document.body.scrollHeight / 4; // 25%

			if (!this.isVisible && !this._wasVisible) {
				if ($(window).scrollTop() > threshold) {
					this._show();
				}
			}
		}

		_show() {
			this.$element.stop(true, false).fadeIn(200);
			this.isVisible = true;

			if (this._isResponsive()) {
				$('.footer-bar').css('--cta-layer-height', `${this.$element.outerHeight() + 5}px`);
			} else {
				$('.footer-bar').css('--cta-layer-height', ``);
			}
		}

		_hide() {
			this.$element.stop(true, false).fadeOut(200);
			this.isVisible = false;
			this._wasVisible = true;
			$('.footer-bar').css('--cta-layer-height', ``);
		}

		_isResponsive() {
			return $(window).width() < 1024;
		}

		_setOffset() {
			this.atBottom = false;

			if ((window.innerHeight + window.scrollY + 30) >= document.body.offsetHeight && this.isVisible) {
				this.atBottom = true;
				this.$element.addClass('scrolled-bottom');
			} else if (this.isVisible) {
				this.atBottom = false;
				this.$element.removeClass('scrolled-bottom');
			}
		}
	}

	return CtaLayer._getElements(Selector.CTA_LAYER, CtaLayer);
})();

export default CtaLayer;
